import { loadScript } from '@ifeng-fe/ui_base';

const handleAd = async ad => {
    let callbackFn = null;

    try {
        if (ad.preload) {
            let list = [];
            let index = 0;

            if (typeof ad.preload === 'string') {
                list = [ad.preload];
            } else {
                list = ad.preload;
            }

            while (list.length > index) {
                const scriptUrl = list[index];

                console.log('load', scriptUrl);

                await loadScript(scriptUrl, { cache: false, reload: false });
                ++index;
            }
        }

        callbackFn = new Function(`return ${ad.callback}`)();
    } catch (error) {
        const adData = {};

        /* eslint-disable no-undef */
        if (allData) {
            for (const [key, value] of Object.entries(allData)) {
                if (value === ad) {
                    adData['key'] = key;
                    adData['value'] = value;
                }
            }
        }
        /* eslint-enable no-undef */

        error.message = `AdError - ${error.message};`;
        error.message += `AdInfo - ${JSON.stringify(adData)}`;

        console.error(error);
        console.error('AdError - AdData', adData);

        if (window && window.BJ_REPORT) window.BJ_REPORT.report(error, false, 'ad');
    }

    return callbackFn;
};

export { handleAd };
